import {
  formatMerchantMoneyMinor,
  healthBadge,
  type MerchantBadgeView,
} from "../view-model-formatters.js";
import type { ProductRow, ProductTone } from "./models.js";

export function productStatusBadge(product: ProductRow): MerchantBadgeView {
  if (product.status === "ACTIVE" && product.eligible) return { label: "Eligible", tone: "green" };
  if (product.status === "ACTIVE") return { label: "Not eligible", tone: "orange" };
  if (product.status === "DELETED" || product.status === "ARCHIVED")
    return { label: product.status, tone: "gray" };
  return { label: product.status, tone: "blue" };
}

export function inventoryHealthBadge(product: ProductRow): MerchantBadgeView {
  return healthBadge(product.inventoryHealth === "FRESH" ? "HEALTHY" : "DEGRADED");
}

export function productPriceRange(product: ProductRow): string {
  if (product.minPriceMinor === product.maxPriceMinor)
    return formatMerchantMoneyMinor(product.minPriceMinor, product.currency);
  return `${formatMerchantMoneyMinor(product.minPriceMinor, product.currency)} - ${formatMerchantMoneyMinor(product.maxPriceMinor, product.currency)}`;
}

export function formatProductCount(value: number): string {
  return new Intl.NumberFormat(undefined, { maximumFractionDigits: 0 }).format(value);
}

export function formatProductDate(value: string): string {
  return new Intl.DateTimeFormat(undefined, { dateStyle: "medium", timeStyle: "short" }).format(
    new Date(value),
  );
}

export function productStatusTone(status: string): ProductTone {
  if (status === "ACTIVE") return "good";
  if (status === "DRAFT") return "warning";
  if (status === "ARCHIVED" || status === "DELETED") return "neutral";
  return "neutral";
}

export function productAvailabilityTone(label: string): ProductTone {
  if (label.toLowerCase().includes("out")) return "critical";
  if (label.toLowerCase().includes("low") || label.toLowerCase().includes("unknown"))
    return "warning";
  return "good";
}

export function productSyncTone(status: string): ProductTone {
  if (status === "FAILED") return "critical";
  if (status === "RUNNING" || status === "REPAIR_RUNNING" || status === "PARTIAL") return "warning";
  if (status === "IDLE") return "good";
  return "neutral";
}

export function toneBadgeClass(tone: ProductTone): string {
  if (tone === "good") return "b-green";
  if (tone === "warning") return "b-orange";
  if (tone === "critical") return "b-red";
  return "b-gray";
}
